export default __webpack_public_path__ + "static/media/tech_2.3abb3de3.png";